import { MenuItem as MuiMenuItem } from '@mui/material';

/**
 * Renders a MenuItem. To be used with Select. Consult https://mui.com/material-ui/api/menu-item/ for more info.
 */
export const MenuItem = MuiMenuItem;
